import { FunctionComponent, lazy } from "react";
import styled from "styled-components";
import "./global-styles.css";
const SoftPhone = lazy(() => import("./pages/softPhone/Softphone.component"));

const StyledRoot = styled.div`
  text-align: center;
  min-height: 100vh;
  font-size: calc(10px + 2vmin);
  color: black;
  margin: 0;
`;

const AppWrapper = () => {
  return <App />;
};

const App: FunctionComponent = () => {
  return (
    <StyledRoot>
      <SoftPhone></SoftPhone>
    </StyledRoot>
  );
};

export default AppWrapper;
